import React from 'react';
import CalendarDay from './CalendarDay';

const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];

function MenuCanvas({ menu, apiMessage }) {
  return (
    <div className="menu-canvas" style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '10px', backgroundColor: '#f0f4f8', borderRadius: '12px', margin: '0 10px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflowX: 'auto', overflowY: 'auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, minmax(180px, 1fr))', gap: '10px' }}>
        {days.map(day => (
          <CalendarDay key={day} day={day} meals={menu[day]} />
        ))}
      </div>
      {/* Row for displaying API errors and warnings */}
      {apiMessage && (
        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#fff3cd', color: '#856404', borderRadius: '8px', border: '1px solid #ffeeba', whiteSpace: 'pre-wrap', width: '100%', boxSizing: 'border-box' }}>
          <strong>Note from AI:</strong><br />
          {apiMessage}
        </div>
      )}
    </div>
  );
}

export default MenuCanvas;
